import React, { useEffect, useState } from "react";
import { IconButton, List, ListItem, ListItemText, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Input,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Form, useNavigate } from "react-router-dom";
import { DropdownChangeEvent } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { assetFamilyMaster, assetType, CapexAttachments, CodeTypeMaster, CountryMaster, imageAttachments, LogisticsAttachments, ManufacturerMaster, ownerAssetMaster, ProjectMaster, RegionMaster } from "../types/assetTypes";
import { CustomMessage, Loader } from "../const/Spinner";
import { enqueueSnackbar } from "notistack";
import {
  createAssetData,
  getAssetByIdData,
  getClassCodeByFamilyAssetId,
  
  updateAssetData,
  uploadFiles,
} from "../api/Services/assetServices";
import { Button } from "primereact/button";
import {
  getCountryAssetMasterDataList,
  getManufacturerAssetMasterDataList,
  getOwnerAssetMasterDataList,
  getTechniqueAssetMasterDataList,
  getCurrencyAssetMasterDataList,
 
  getProjectMasterDataList,
  getCountryByProjectId,
  getClassCodeMasterDataList,
  getModelByManufacturerId,
  getRegionByCountryId,
  getProjectByRegionId
} from "../api/Services/masterServie";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../store/CommonSlice";
import dayjs from "dayjs";
import DownloadIcon from "@mui/icons-material/Download";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../api/endpoint";
import ReusablePrimeButton from "../Component/Buttons/ReusablePrimeButton";
import ImagePreview from "../Component/ImagePreview";
import { RootState } from "../store/Reduxstore";

interface CreateAssetProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  assetId: number | null;
  setAssetId: React.Dispatch<React.SetStateAction<number | null>>;
  selectedValue: number | null;
  getListOfSelectedProducts: () => void;
  selectedFamilyName: string;
  userId: number;
  selectedFamily: assetFamilyMaster[];
}
const CreateAsset: React.FC<CreateAssetProps> = ({
  setOpen,
  assetId,
  setAssetId,
  selectedValue,
  userId,
  getListOfSelectedProducts,
  selectedFamilyName,
  selectedFamily
}) => {
  console.log("Value: ", selectedValue);


const [classCodes, setClassCodes] = useState<
  { label: string; value: number; classCode: string }[]
>([]);

useEffect(() => {
  const fetchCodeTypes = async (id: number) => {
    try {
      const result = await getClassCodeByFamilyAssetId(id);

      if (Array.isArray(result.data) && result.data.length > 0) {
        const formattedData = result.data.map((classCodes) => ({
          label: classCodes.classCodeDes,           // for dropdown label
          value: classCodes.classCodeId,         // for dropdown value
          classCode: classCodes.classCode ?? "",
        }));

        // Insert a default option at the beginning
        formattedData.unshift({
          label: "-- Select Code Type --",
          value: 0,
          classCode: "",
        });

        setClassCodes(formattedData);
      } else {
        setClassCodes([]);
      }
    } catch (error) {
      console.error("Error fetching code types:", error);
      setClassCodes([]);
    }
  };

  if (selectedValue) {
    fetchCodeTypes(selectedValue);
  }
}, [selectedValue]);




  const dispatch = useDispatch();
  const userDetails = useSelector((state: RootState) => state.auth)
  console.log(userDetails);

  const [formData, setFormData] = useState<assetType>({
    assetId: 0,
  localCode: "",
  assetOwnerId: 0,
  assetOwnerName: "",
  harmonyCode: "",
  regionId: 0,
  regionName: "",
 
  familyAssetId: 0,
  familyAssetName: "",
  assetName: "",
   classCodeId: 0,
  harmonyName: "",

  srNo: 0,
  techniqueId: [],
 
  techniqueName: "",
  techAdditional: "",
  currentLocationId: 0,
  countryName: "",
  countryId: 0,
  modelId: 0,
  modelName: "",
  manufacturerId: 0,
  manufacturerName: "",
  manufacturerDate: null,
  purchaseDate: null,
  insuranceValue: 0,
  insuranceCurrencyId: 0,
  insuranceCurrency: "",
  capexFormRef: "",
  capexAttachments: [],
  logisticsAttachments: [],
  singleShift: 0,
  doubleShift: 0,
  coo: "",
  comments: "",
  length: 0,
  width: 0,
  height: 0,
  weight: 0,
  hsCode: "",
  optional1: 0,
  optional2: 0,
  optional3: 0,
  optional4: 0,
  optional5: "",
  optional6: "",
  optional7: "",
  optional8: "",
  attachments: [],
  imageAttachments: [],
  option2: "",
  classCode: "",
  classCodeDes: "",
 
  globalCode: "",
  projectId: 0,
  projectName: '',
  intext: "",
  contractType: "",
  purchaseValue: 0,
  insuranceCompany: "",
  userId: userDetails.userId ?? 0, 
  toolequip: "", // Ensure userDetails is in scope
  //  logisticsAttachmentId: 0,
  //   capexAttachmentId: 0,
    noCharge: 0,
    halfShiftCharge: 0,
    fullShiftCharge: 0,
    doubleShiftCharge: 0,
    rateop1: 0,
    rateop2: 0,
    groupCode: 0,

  }); 

  console.log("AssetId:", assetId);

  const [assetOwners, setAssetOwners] = useState<
    { label: string; value: number }[]
  >([]);
  const [technique, setTechnique] = useState<
    { label: string; value: number }[]
  >([]);
  const [manufacturer, setManufacturer] = useState<
    { label: string; value: number }[]
  >([]);

  const [currentLocation, setCurrentLocation] = useState<
    { label: string; value: number }[]
  >([]);

  const [region, setRegions] = useState<
   { label: string; value: number }[]
  >([{label: "Select a region", value: 0 }]);

  const [insuranceCurrency, setInsuranceCurrency] = useState<
    { label: string; value: number }[]
  >([]);

  const [project, setProjects] = useState<
    { label: string; value: string | number }[]
    >([]);

  useEffect(() => {
      if (currentLocation.length === 0) getCurrentLocationList(1,PAGESEND);
    }, [currentLocation]);
  
  

  useEffect(() => {
    if (assetOwners.length === 0) getAssetOwners(1,PAGESEND);
  }, [assetOwners]);
  useEffect(() => {
    if (technique.length === 0) getAssetTechnique(1,PAGESEND);
  }, [technique]);
  useEffect(() => {
    if (manufacturer.length === 0) getManufacturerList(1,PAGESEND);
  }, [manufacturer]);
  
  useEffect(() => {
    if (insuranceCurrency.length === 0) getInsuranceCurrencyList(1,PAGESEND);
  }, [insuranceCurrency]);

// 🟡 Fetch Current Location (Countries)
useEffect(() => {
  if (formData.currentLocationId && currentLocation.length === 0) {
    getCurrentLocationList(PAGESTART, PAGESEND);
  }
}, [formData.currentLocationId, currentLocation]);

// 🟡 Fetch Asset Owners
useEffect(() => {
  if (formData.assetOwnerId && assetOwners.length === 0) {
    getAssetOwners(PAGESTART, PAGESEND);
  }
}, [formData.assetOwnerId, assetOwners]);

// 🟡 Fetch Techniques
useEffect(() => {
  if (formData.techniqueId && technique.length === 0) {
    getAssetTechnique(PAGESTART, PAGESEND);
  }
}, [formData.techniqueId, technique]);

// 🟡 Fetch Manufacturers
useEffect(() => {
  if (formData.manufacturerIds?.length && manufacturer.length === 0) {
    getManufacturerList(PAGESTART, PAGESEND);
  }
}, [formData.manufacturerIds, manufacturer]);

// 🟡 Fetch Models by Manufacturer
useEffect(() => {
  if (formData.manufacturerIds?.length) {
    formData.manufacturerIds.forEach((manufacturerId: number) => getModelList(manufacturerId));
  }
}, [formData.manufacturerIds]);


// 🟡 Fetch Insurance Currencies
useEffect(() => {
  if (formData.insuranceCurrencyId && insuranceCurrency.length === 0) {
    getInsuranceCurrencyList(PAGESTART, PAGESEND);
  }
}, [formData.insuranceCurrencyId, insuranceCurrency]);



// 🟡 Fetch Regions
useEffect(() => {
  if (formData.currentLocationId) {
    getRegionList(formData.currentLocationId);
  }
}, [formData.currentLocationId]);

// 🟡 Fetch Projects
useEffect(() => {
  if (formData.regionId) {
    getProjectList(formData.regionId);
  }
}, [formData.regionId]);

  const getAssetOwners = async (page: number, rows: number) => {
   
    try {
      const { data, status } = await getOwnerAssetMasterDataList(page, rows,{manufacturerId:{value:"",matchMode: "startsWith"}});
      if (status.code === 200 && data?.length > 0) {
        const updatedData = data.map((val) => ({
          value: val.assetOwnerId,
          label: val.assetOwnerName,
        }));
        // updatedData.unshift({ label: "--Select--", value: 0 });
        setAssetOwners(updatedData);
      } 
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } 
  };

  const getAssetTechnique = async (page: number, rows: number) => {
   
    try {
      const { data, status } = await getTechniqueAssetMasterDataList(page, rows,{techniqueId:{value:"",matchMode: "startsWith"}});
      if (status.code === 200 && data?.length > 0) {
        const updatedData = data.map((val) => ({
          value: val.techniqueId,
          label: val.techniqueName,
        }));
        // updatedData.unshift({ label: "--Select--", value: 0 });
        setTechnique(updatedData);
      } 
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } 
  };

  const getManufacturerList = async (page: number, rows: number) => {
  
    try {
      const { data, status } = await getManufacturerAssetMasterDataList(page, rows,{manufacturerId:{value:"",matchMode: "startsWith"}});
      if (status.code === 200 && data?.length > 0) {
        const updatedData = data.map((val) => ({
          value: val.manufacturerId,
          label: val.manufacturerName,
        }));
        // updatedData.unshift({ label: "--Select--", value: 0 });
        setManufacturer(updatedData);
      } 
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } 
  };



// State declaration
   const [models, setModels] = useState<{ label: string; value: number }[]>([{label: "Select a model", value: 0 }]);
       


      const getModelList = async (manufacturerId: number) => {
       
        try {
          const { data, status } = await getModelByManufacturerId(manufacturerId);

          if (status.code === 200 && Array.isArray(data) && data.length > 0) {

              const updatedData: { label: string; value: number }[] = data.map(
                (val: { modelId: number; modelName: string }) => ({
                  label: val.modelName,
                  value: val.modelId,
                })
              );

            

            // add default option
            // updatedData.unshift({ label: "--Select--", value: 0 });

            setModels(updatedData);
            console.log("Mapped model data:", updatedData);
          } else {
            setModels([{ label: "--Select--", value: 0 }]);
          }
        } catch (error: any) {
          CustomMessage(error?.message, "error", enqueueSnackbar);
        } 
      };

       const getRegionList = async (currentLocationId: number) => {
            
              try {
                  const { data, status } = await getRegionByCountryId(currentLocationId);
          
                  if (status.code === 200 && data?.regions?.length > 0) {
                      const updatedData: { label: string; value: number }[] = data.regions.map(
                          (val: { regionId: number; regionName: string }) => ({
                              value: val.regionId, // Convert to string
                              label: val.regionName ?? "", // Ensure it's a string
                          })
                      );
                      // updatedData.unshift({ label: "--Select--", value: 0 });
                      setRegions(updatedData);
                  }  else {
            // ✅ Set to empty array when no data or non-200 status
            setRegions([]);
            setFormData((prev) => ({
              ...prev,
              // projectId: "",
              regionName: ""
            }));
             setProjects([]);
            setFormData((prev) => ({
              ...prev,
              // projectId: "",
              projectName: ""
            }));
             }
                  
              } catch (error: any) {
                setRegions([]);
                setFormData((prev) => ({
              ...prev,
              // projectId: "",
              regionName: ""
            }));
            setProjects([]);
            setFormData((prev) => ({
              ...prev,
              // projectId: "",
              projectName: ""
            }));

                  CustomMessage(error?.message, "error", enqueueSnackbar);
              } 
        };


    const getCurrentLocationList = async (page: number, rows: number) => {
       
        try {
          const { data, status } = await getCountryAssetMasterDataList(page, rows,{currentLocationId:{value:"",matchMode: "startsWith"}});
          if (status.code === 200 && data?.length > 0) {
            const updatedData = data.map((val) => ({
              value: val.currentLocationId,
              label: val.countryName,
            }));
            // updatedData.unshift({ label: "--Select--", value: 0 });
        setCurrentLocation(updatedData);
        console.log("Mapped location data:", updatedData);
        
      } 
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } 
  };

  const getInsuranceCurrencyList = async (page: number, rows: number) => {
  
    try {
      const { data, status } = await getCurrencyAssetMasterDataList(page, rows, {insuranceCurrencyId:{value:"",matchMode: "startsWith"}});
      if (status.code === 200 && data?.length > 0) {
        const updatedData = data.map((val) => ({
          value: val.insuranceCurrencyId,
          label: val.insuranceCurrency ?? "", // Ensure a string is assigned
        }));
        
        // updatedData.unshift({ label: "--Select--", value: 0 });
        setInsuranceCurrency(updatedData);
      } 
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } 
  };


const getProjectList = async (regionId: number) => {
  
  try {
    const { data, status } = await getProjectByRegionId(regionId);

   if (status.code === 200 && data.projects.length > 0) {
      const updatedData = data.projects.map((val) => ({
        value: val.projectId.toString(),
        label: val.projectName,
      }));
      updatedData.unshift({ label: "--Select--", value: "" });
      setProjects(updatedData);
    }
     else if (status.code === 200 && Array.isArray(data?.projects) && data.projects.length === 0) {
      setProjects([{ label: "Select Project", value: "" }]);
    } 
    // ✅ Handle unexpected structure
    else {
      setProjects([{ label: "Select Project", value: ""}]);
      setFormData((prev) => ({
        ...prev,
        // projectId: "",
        projectName: ""
      }));
    }
      
  } catch (error: any) {
    CustomMessage(error?.message, "error", enqueueSnackbar);
  } 
};

const handleSelectManufacturerChange = (
  e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
  name: keyof ManufacturerMaster,
  name2: keyof ManufacturerMaster
) => {
  const label = (e.target as { value: { label: string } }).value?.label || "";
  const value = (e.target as { value: { value: number } }).value?.value || 0;

  const updatedData: Partial<assetType> = { ...formData };

  // Dynamically assign manufacturer fields
  (updatedData as any)[name] = label;
  (updatedData as any)[name2] = value;

  // ✅ Reset model fields
  (updatedData as any)["modelName"] = "";
  (updatedData as any)["modelId"] = 0;

  setFormData(updatedData as assetType);

  // 🔁 Fetch models based on selected manufacturer
  getModelList(value);
};



    // const handleSelectManufacturerChange = (
    //       e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    //       name: keyof ManufacturerMaster,
    //       name2: keyof ManufacturerMaster
    //     ) => {
    //       const updatedData: Partial<assetType> = { ...formData};
        
    //       (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
    //       (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;
    
        
    //       setFormData(updatedData as assetType);
    //       getModelList((e.target as { value: { value: number } }).value?.value || 0);
         
          
    // };


  const handleSelectProjectChange = (
          e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
          name: keyof ProjectMaster,
          name2: keyof ProjectMaster
        ) => {
          const updatedData: Partial<assetType> = { ...formData};
        
          (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
          (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;   
        
          setFormData(updatedData as assetType);     
         
          
    };

    const handleSelectCountryChange = (
      e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
      name: keyof CountryMaster,
      name2: keyof CountryMaster
    ) => {
      const label = (e.target as { value: { label: string } }).value?.label || "";
      const value = (e.target as { value: { value: number } }).value?.value || 0;

      const updatedData: Partial<assetType> = { ...formData };

      // Dynamically set selected country fields
      (updatedData as any)[name] = label;
      (updatedData as any)[name2] = value;

      // ✅ Reset region and project fields (use actual keys from assetType)
      (updatedData as any)["regionName"] = "";
      (updatedData as any)["regionId"] = 0;
      (updatedData as any)["projectName"] = "";
      (updatedData as any)["projectId"] = 0;

      setFormData(updatedData as assetType);

      // 🔁 Fetch regions for the selected country
      getRegionList(value);
    };


    // const handleSelectCountryChange = (
    //       e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    //       name: keyof CountryMaster,
    //       name2: keyof CountryMaster
    //     ) => {
    //       const updatedData: Partial<assetType> = { ...formData};
        
    //       (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
    //       (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;

          
    
        
    //       setFormData(updatedData as assetType);
    //       getRegionList((e.target as { value: { value: number } }).value?.value || 0);  
    // };

    const handleSelectRegionChange = (
          e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
          name: keyof RegionMaster,
          name2: keyof RegionMaster
        ) => {
          const updatedData: Partial<assetType> = { ...formData};
        
          (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
          (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;
    
        
          setFormData(updatedData as assetType);
          getProjectList((e.target as { value: { value: number } }).value?.value || 0);  
    };



  const handleSubmit = async (e: any) => {
    e?.preventDefault();
    if (!selectedValue) {
      CustomMessage("Select the family", "error", enqueueSnackbar);
      return;
    }
    const updatedData = { ...formData };
    updatedData.familyAssetId = selectedValue;
    //updatedData.currentLocationId = (formData.currentLocationId === 0 || formData.currentLocationId === null) ? null : formData.currentLocationId;
    updatedData.familyAssetId = selectedValue;

  // Convert 0s to null for all ID fields dynamically
// Convert 0s to null for all ID fields dynamically
const idFields = [
  "assetOwnerId",
  "familyAssetId",
  "manufacturerId",
  "techniqueId",
  "currentLocationId",
  "insuranceCurrencyId"
];

idFields.forEach((key) => {
  if (updatedData[key as keyof typeof updatedData] === 0) {
    updatedData[key as keyof typeof updatedData] = null;
  }
});

// Sanitize numeric fields
const numericFields = [
  "srNo", "length", "width", "height", "weight", "optional1",
  "optional2", "optional3", "optional4", "insuranceValue", "purchaseValue",
  "singleShift", "doubleShift"
];

numericFields.forEach((key) => {
  const value = updatedData[key as keyof typeof updatedData];
  updatedData[key as keyof typeof updatedData] =
    isNaN(Number(value)) ? 0 : Number(value);
});



    if (updatedData.manufacturerDate)
      updatedData.manufacturerDate = dayjs(updatedData.manufacturerDate).format(
        "YYYY-MM-DD"
      );
    if (updatedData.purchaseDate)
      updatedData.purchaseDate = dayjs(updatedData.purchaseDate).format(
        "YYYY-MM-DD"
      );
    const saveMethod =
      updatedData.assetId === 0 ? createAssetData : updateAssetData;
    dispatch(setLoading(true));
    try {
      const response = await saveMethod(updatedData);
      if (response.status === 201 || response.status === 200) {
        CustomMessage(
          updatedData.assetId === 0 ? "Data Added" : "Data Updated",
          "success",
          enqueueSnackbar
        );
        handleClear();
        // getListOfSelectedProducts();
      } else {
        CustomMessage("Error in adding the data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  }; 
  
  
  const handleClear = () => {
    setFormData({
      assetId: 0,
      typeCodeId: 0,
      localCode: "",
      assetOwnerId: 0,
      assetOwnerName: "",
      harmonyCode: "",
      typeCode: "",
      familyAssetId: 0,
      familyAssetName: "",
      assetName: "",
      harmonyName: "",
      toolequip: "",
      regionId: 0,
      regionName: "",
      srNo: 0,
      techniqueId: [],
       classCodeId: 0,
      techniqueName: "",
      techAdditional: "",
      currentLocationId: 0,
      countryName: "",
      countryId: 0,
      manufacturerId: 0,
      manufacturerName: "",
      manufacturerDate: null,
      purchaseDate: null,
      insuranceValue: 0,
      modelId: 0,
  modelName: "",
      insuranceCurrencyId: 0,
      insuranceCurrency: "",
      capexFormRef: "",
      capexAttachments: [],
      logisticsAttachments: [],
      singleShift: 0,
      doubleShift: 0,
      coo: "",
      comments: "",
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      hsCode: "",
      optional1: 0,
      optional2: 0,
      optional3: 0,
      optional4: 0,
      optional5: "",
      optional6: "",
      optional7: "",
      optional8: "",
      attachments: [],
      imageAttachments: [],
      option2: "",
      classCode: "",
      classCodeDes: "",
     
      typeCodeDes: "",
      globalCode: "",
      projectId: 0,
    intext: "",
      contractType: "",
      purchaseValue: 0,
      insuranceCompany: "",
       projectName: '',
      userId: userDetails.userId ?? 0,  // Ensure userDetails is in scope
      noCharge: 0,
      halfShiftCharge: 0,
      fullShiftCharge: 0,
      doubleShiftCharge: 0,
      rateop1: 0,
      rateop2: 0,
      groupCode: 0,
    });
    setOpen(false);
  };

  useEffect(() => {
    if (assetId !== null && assetId != 0) {
      getAssetDataById();
    }
  }, [assetId]);


  const getAssetDataById = async () => {
    if (!assetId) {
      CustomMessage("asset Id not selected", "error", enqueueSnackbar);
      return;
    }
    dispatch(setLoading(true));
    try {
      const response = await getAssetByIdData(assetId);
      if (response.data !== null) {
        const combinedData = {
          ...response.data,
          userId: userId ?? 0, // Add userId herex
        };
        setFormData(combinedData);
        console.log("combinedData:", combinedData); // ✅ move it here
      } else {
       // CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      setAssetId(null);
      dispatch(setLoading(false));
    }
  };
  

  console.log("form datee:", formData);
  console.log("Id:", userId);
  
  const handleChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: string
  ) => {
    const value = e.target ? e.target.value : e.value;
    setFormData((prev) => ({
      ...prev,
      [name]:
        typeof value === "object" && value !== null
          ? value?.value
          : (value ?? ""),
    }));
  };

  const handleSelectChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> |any,
    name: keyof typeof formData,
    name2: keyof typeof formData
  ) => {
    const updatedData = { ...formData };
  
    if ("value" in e.target) {
      updatedData[name as keyof typeof formData] = (e.target as { value: { label: string } }).value?.label || "" as string;
      updatedData[name2] = (e.target as any).value?.value || 0;
    }
  
    setFormData(updatedData);
  };  


  const removeImageFile = (index: number) => {
    setFormData((prev) => ({
      ...prev,
      imageAttachments: prev.imageAttachments.filter((_, i) => i !== index),
    }));
  };

  
  const removeCapexImageFile = (index: number) => {
    setFormData((prev) => ({
      ...prev,
      capexAttachments: prev.capexAttachments.filter((_, i) => i !== index),
    }));
  };

  
  const removeLogisticsImageFile = (index: number) => {
    setFormData((prev) => ({
      ...prev,
      logisticsAttachments: prev.logisticsAttachments.filter((_, i) => i !== index),
    }));
  };

  const removeFile = (index: number) => {
    setFormData((prev) => ({
      ...prev,
      attachments: prev.attachments.filter((_, i) => i !== index),
    }));
  };

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    if (!fileList || fileList.length === 0) {
        CustomMessage("No file selected", 'error', enqueueSnackbar);
        return;
    }
    const fileArray = Array.from(fileList); // Convert FileList to an array

    dispatch(setLoading(true)); // Set loading before upload starts

    try {
        const uploadPromises = fileArray.map(async (file) => {
            if (!file){
              CustomMessage("file not found",'error',enqueueSnackbar);
              return;
            };
            const data = new FormData();
            data.append('file', file); // Ensure the key matches backend expectations       

            const response = await uploadFiles(data);
            if (response.status.code === 201) {
              // Update formData with the uploaded files
              setFormData((prev) => ({
                ...prev,
                attachments: Array.isArray(prev.attachments)
                  ? [...prev.attachments, { ...response.data }]
                  : [{ ...response.data }]
              }));
              return response.data;
            } else {
              CustomMessage(`Upload failed with status: ${response.status.code}`, 'error', enqueueSnackbar);
              throw new Error(`Upload failed with status: ${response.status.code}`);
            }
        });

        const uploadedFiles = await Promise.all(uploadPromises); // Wait for all uploads to complete
        CustomMessage("All files uploaded successfully", 'success', enqueueSnackbar);

    } catch (error: any) {
      CustomMessage(`File upload error: ${error.message}`, 'error', enqueueSnackbar);
    } finally {
      dispatch(setLoading(false)); // Set loading to false after all uploads finish
    }
  };
  const handleCapexFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (!file) {
      CustomMessage("No file selected", 'error', enqueueSnackbar);
      return;
    }

    // ⚠️ Allow only one file at a time (image or document)
    if (formData.capexAttachments && formData.capexAttachments.length > 0) {
      CustomMessage(
        "Only one file can be uploaded at a time. Please remove the existing file before uploading a new one.",
        'warning',
        enqueueSnackbar
      );
      return;
    }

    // ✅ Allowed MIME types (images + common docs)
    const allowedTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/webp',
      'application/pdf',
      'application/msword', // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    ];

    if (!allowedTypes.includes(file.type)) {
      CustomMessage("Only image and document files (PDF, DOCX, XLSX) are allowed.", 'error', enqueueSnackbar);
      return;
    }

    dispatch(setLoading(true));

    try {
      const data = new FormData();
      data.append('file', file);

      const response = await uploadFiles(data);

      if (response.status.code === 201) {
        const uploadedAttachment: CapexAttachments = {
          capexAttachmentId: response.data.attachmentId,
          attachmentId: response.data.attachmentId,
          name: response.data.name,
          savedAttachmentName: response.data.savedAttachmentName,
        };

        setFormData((prev) => ({
          ...prev,
          capexAttachments: [uploadedAttachment],
        }));

        CustomMessage("File uploaded successfully", 'success', enqueueSnackbar);
      } else {
        CustomMessage(`Upload failed with status: ${response.status.code}`, 'error', enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(`File upload error: ${error.message}`, 'error', enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

   const handleLogisticsFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (!file) {
      CustomMessage("No file selected", 'error', enqueueSnackbar);
      return;
    }

    // ⚠️ Allow only one file at a time (image or document)
    if (formData.logisticsAttachments && formData.logisticsAttachments.length > 0) {
      CustomMessage(
        "Only one file can be uploaded at a time. Please remove the existing file before uploading a new one.",
        'warning',
        enqueueSnackbar
      );
      return;
    }

    // ✅ Allowed MIME types (images + common docs)
    const allowedTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/webp',
      'application/pdf',
      'application/msword', // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    ];

    if (!allowedTypes.includes(file.type)) {
      CustomMessage("Only image and document files (PDF, DOCX, XLSX) are allowed.", 'error', enqueueSnackbar);
      return;
    }

    dispatch(setLoading(true));

    try {
      const data = new FormData();
      data.append('file', file);

      const response = await uploadFiles(data);

      if (response.status.code === 201) {
        const uploadedAttachment: LogisticsAttachments = {
          logisticsAttachmentId: response.data.attachmentId,
          attachmentId: response.data.attachmentId,
          name: response.data.name,
          savedAttachmentName: response.data.savedAttachmentName,
        };

        setFormData((prev) => ({
          ...prev,
          logisticsAttachments: [uploadedAttachment],
        }));

        CustomMessage("File uploaded successfully", 'success', enqueueSnackbar);
      } else {
        CustomMessage(`Upload failed with status: ${response.status.code}`, 'error', enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(`File upload error: ${error.message}`, 'error', enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  const handleImageFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
  
    if (!file) {
      CustomMessage("No file selected", 'error', enqueueSnackbar);
      return;
    }
  
    // ⚠️ Check if an image already exists
    if (formData.imageAttachments && formData.imageAttachments.length > 0) {
      CustomMessage(
        "Only one image can be uploaded at a time. Please remove the existing image before uploading a new one.",
        'warning',
        enqueueSnackbar
      );
      return;
    }
  
    // ✅ Check for valid image types only (jpg, jpeg, png, webp)
    const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!validImageTypes.includes(file.type)) {
      CustomMessage("Only image file is allowed, not documents.", 'error', enqueueSnackbar);
      return;
    }
  
    dispatch(setLoading(true));
  
    try {
      const data = new FormData();
      data.append('file', file);
  
      const response = await uploadFiles(data);
  
      if (response.status.code === 201) {
        const uploadedAttachment: imageAttachments = {
          imageAttachmentId: response.data.attachmentId,
          attachmentId: response.data.attachmentId,
          name: response.data.name,
          savedAttachmentName: response.data.savedAttachmentName,
        };
  
        setFormData((prev) => ({
          ...prev,
          imageAttachments: [uploadedAttachment],
        }));
  
        CustomMessage("Image uploaded successfully", 'success', enqueueSnackbar);
      } else {
        CustomMessage(`Upload failed with status: ${response.status.code}`, 'error', enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(`File upload error: ${error.message}`, 'error', enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleSelectOption1Change = (e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any) => {
        const updatedData: Partial<assetType> = { ...formData };
        updatedData. intext = (e.target as { value: { label: string } }).value?.label || "";    
        setFormData(updatedData as assetType);
      }
  const handleSelectOption3Change = (e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any) => {
        const updatedData: Partial<assetType> = { ...formData };
        updatedData. toolequip = (e.target as { value: { label: string } }).value?.label || "";    
        setFormData(updatedData as assetType);
      }
  
  
  console.log("data:", formData);
  const handleSelectOption2Change = (e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any) => {
    const updatedData: Partial<assetType> = { ...formData };
    updatedData.option2 = (e.target as { value: { label: string } }).value?.label || "";    
    setFormData(updatedData as assetType);
  }

    console.log("data:", formData);
  const handleSelect2Change = (e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any) => {
    const updatedData: Partial<assetType> = { ...formData };
    updatedData.contractType = (e.target as { value: { label: string } }).value?.label || "";    
    setFormData(updatedData as assetType);
  }

  const handleSelectClassCodeChange = (
        e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
        name: keyof assetType,
        name2: keyof assetType
      ) => {
        const updatedData: Partial<assetType> = { ...formData };
        console.log('description: ', e.target)

       
      
        if ("value" in e.target) {
          if(name=="classCodeDes")
          {
             updatedData.classCode = (e.target as { value: { classCode: string } }).value?.classCode || "";
           
          }
          updatedData[name] = (e.target as { value: { label: string } }).value?.label || "";
          updatedData[name2] = (e.target as { value: { value: number } }).value?.value || 0;
        }
      
        setFormData(updatedData as assetType);
      };

console.log("data:", formData);
  const optionalFields = [
    { key: "optional1Number", formKey: "optional1", type:"number" },
    { key: "optional2Number", formKey: "optional2", type:"number" },
    { key: "optional3Number", formKey: "optional3", type:"number" },
    { key: "optional4Number", formKey: "optional4", type:"number" },
    { key: "optional5String", formKey: "optional5", type:"text" },
    { key: "optional6String", formKey: "optional6", type:"text" },
    { key: "optional7String", formKey: "optional7", type:"text" },
    { key: "optional8String", formKey: "optional8", type:"text" },
  ];


return (
  <>
    <div>
    <Typography
          variant="h6"
          gutterBottom
          sx={{ marginBottom: 1, color: "#004489", fontSize: "16px", fontWeight: "bold" }}
        >
          Main- {selectedFamilyName}
        </Typography>
      <Box
        sx={{
          borderRadius: 2,
          boxShadow: 3,
          padding: 2, // Add padding for better spacing
          backgroundColor: "#FFFFFF",
          border: "12px solid #F9F9F9;",
          marginBottom: 3,
        }}
        component="form"
        
      >
       
        <Grid container spacing={3}>
           {/* owner */}
          <Grid item xs={12} sm={6} md={3}>
            <h6>Select an Owner</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-placeholder="Select an Owner"
                className="bg-white"
                id="assetOwnerName"
                value={{
                  label: formData.assetOwnerName,
                  value: formData.assetOwnerId,
                }}
                options={assetOwners}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  handleSelectChange({ target: { value: newValue } }, "assetOwnerName", "assetOwnerId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select an owner"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <h6>Select  a Class code name</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-placeholder="Select a class code"
                className="bg-white"
                id="classCode"
                value={{
                  label: formData.classCodeDes?? "",
                  value: formData.classCodeId?? "", 
                  classCode: formData.classCode,
                }}
                options={classCodes}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  handleSelectClassCodeChange({ target: { value: newValue } }, "classCodeDes", "classCodeId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select a class code name"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <h6>Class Code</h6>
            <FormControl fullWidth>
              <Input
                readOnly
                placeholder={formData.classCode ? "" : "Class code"} // Hide placeholder when value exists
                value={formData.classCode}
                onChange={(e) => handleChange(e, "classCode")}
              />
              {/* <Input
                id="classDescription"
                value={formData.classDescription}
                className="bg-white"
                onChange={(e) => handleChange(e, "classDescription")}
              /> */}
            </FormControl>
          </Grid>
           
          
          {/* Localcode */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <h6>Local Code</h6>
              <Input
                id="localCode"
                className="bg-white"
                value={formData.localCode}
                onChange={(e) => handleChange(e, "localCode")}
              />
            </FormControl>
          </Grid>
          {/* AssetName */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <h6>Asset Name</h6>
              <Input
                id="assetName"
                className="bg-white"
                value={formData.assetName}
                onChange={(e) => handleChange(e, "assetName")}
              />
            </FormControl>
          </Grid>           
          <Grid item xs={12} sm={6} md={3}>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              {/* File Upload */}
              <FormControl fullWidth sx={{ flex: 1 }}>
                <h6>Attach Asset Image</h6>
                <Input
                  id="fileUpload"
                  className="bg-white"
                  type="file"
                  inputProps={{ accept: "image/*" }} // Only image files allowed
                  onChange={handleImageFileUpload}
                  style={{ fontSize: "14px" }}
                  
                />
              </FormControl>

              {/* Preview List */}
              {formData?.imageAttachments?.length > 0 && (
                <List
                  dense
                  sx={{
                    bgcolor: "background.paper",
                    maxHeight: 200,
                    overflowY: "auto",
                    width: "auto",
                    p: 1,
                    border: "1px solid #eee",
                    borderRadius: 2,
                    flexShrink: 0,
                  }}
                >
                  {formData.imageAttachments.map((file, index) => {
                    const fileUrl = `${FILE_DOWNLOAD_PREVIEW + file.attachmentId}`;
                    return (
                      <ListItem
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          p: 0.5,
                        }}
                      >
                        {/* Image */}
                        <Box sx={{ width: 59, height: 59, flexShrink: 0 }}>
                          <ImagePreview
                            src={fileUrl}
                            alt={file?.name || "Image Preview"}
                          
                            style={{
                              width: "59px",
                              height: "59px",
                              borderRadius: "50%",
                              objectFit: "cover"
                            }}
                          />
                        </Box>

                        {/* Actions */}
                        <Box display="flex" flexDirection="column" gap={0.5}>
                          <IconButton
                            size="small"
                            onClick={() => {
                              const link = document.createElement("a");
                              link.href = fileUrl;
                              link.setAttribute("download", file.name || "image");
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                          >
                            <DownloadIcon fontSize="small" color="primary" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => removeImageFile(index)}
                          >
                            <CloseIcon fontSize="small" color="error" />
                          </IconButton>
                        </Box>
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </Stack>
          </Grid> 
           <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <h6>Harmony Code</h6>
              <Input
                id="harmonyCode"
                className="bg-white"
                value={formData.harmonyCode}
                onChange={(e) => handleChange(e, "harmonyCode")}
                // startAdornment={<InputAdornment position="start"></InputAdornment>}
              />
            </FormControl>
          </Grid>  
          <Grid item xs={12} sm={6} md={3}>
          <h6>Harmony Name</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="harmonyName">Harmony Name</InputLabel> */}
              <Input
                id="harmonyName"
                className="bg-white"
                value={formData.harmonyName}
                onChange={(e) => handleChange(e, "harmonyName")}
              />
            </FormControl>
          </Grid>
           <Grid item xs={12} sm={6} md={3}>
            <h6>Global Code</h6>
            <FormControl fullWidth>
              <Input
                id="globalCode"
                value={formData.globalCode}
                className="bg-white"
                onChange={(e) => handleChange(e, "globalCode")}
              />
            </FormControl>
          </Grid>
           
          <Grid item xs={12} sm={6} md={3}>
          <h6>Select an Current Location</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-label="Select an Current Location"
                id="currentLocation"
                className="bg-white"
                value={{
                  label: formData.countryName,
                  value: formData.currentLocationId,
                }}
                options={currentLocation}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  handleSelectCountryChange({ target: { value: newValue } }, "countryName", "currentLocationId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select an Current Location"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Select a Region</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-label="Select a Region"
                id="region"
                className="bg-white"
                value={{
                  label: formData.regionName,
                  value: formData.regionId,
                }}
                options={region}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  handleSelectRegionChange({ target: { value: newValue } }, "regionName", "regionId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select an Region"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Select a Project</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-label="Select a Project"
                id="project"
                className="bg-white"
                value={{
                  label: formData.projectName,
                  value: formData.projectId,
                }}
                options={project}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                handleSelectProjectChange({ target: { value: newValue } }, "projectName", "projectId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select a Project"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
          </Grid>
         </Box>
      
    </div>
    <div>
    <Typography
          variant="h6"
          gutterBottom
          sx={{ marginBottom: 1, color: "#004489", fontSize: "16px", fontWeight: "bold" }}
        >
          Others- {selectedFamilyName}
        </Typography>
      <Box
        sx={{
          borderRadius: 2,
          boxShadow: 3,
          padding: 2, // Add padding for better spacing
          backgroundColor: "#FFFFFF",
          border: "12px solid #F9F9F9;",
          marginBottom: 3,
        }}
        component="form"
        
      >
       
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Select Techniques</h6>
            <FormControl fullWidth>
              <Autocomplete
                multiple
                id="techniqueName"
                className="bg-white"
                options={technique} // technique: array of { label, value }
                value={
                  technique.filter((t) =>
                    formData.techniqueId.includes(t.value)
                  )
                } // ✅ convert number[] to full option objects
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) => {
                  const techniqueIds = newValue.map((item) => item.value);
                  setFormData({
                    ...formData,
                    techniqueId: techniqueIds, // ✅ just number[] in state
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select Techniques"
                  />
                )}
                isOptionEqualToValue={(option, value) => option.value === value.value}
              />
            </FormControl>
          </Grid>
           <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
            <h6>Select Tool/Equipment</h6>
              <Autocomplete
                aria-placeholder="Select a Tool/Equipment"
                id="status"
                value={{
                   label: formData.toolequip ?? "", 
                  value: formData.toolequip?.toString() ?? "", 
                }}
                
                //value={{ label: formData.stockCodeId, value: formData.stockCode }}
                options={[{label:"TOOL",value:"TOOL"},{label:"EQUIPMENT",value:"EQUIPMENT"}]}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  handleSelectOption3Change({ target: { value: newValue } })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select tool/equipment"
                    required
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
           <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
            <h6>Select Internal/External</h6>
              <Autocomplete
                aria-placeholder="Select Internal/External"
                id="status"
                value={{
                  label: formData.intext ?? "", 
                  value: formData.intext?.toString() ?? "", 
                }}
                
                //value={{ label: formData.stockCodeId, value: formData.stockCode }}
                options={[{label:"INTERNAL",value:"INTERNAL"},{label:"EXTERNAL",value:"EXTERNAL"}]}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  handleSelectOption1Change({ target: { value: newValue } })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select internal/external"
                    required
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
           <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
            <h6>Select a Contract Type</h6>
              <Autocomplete
                aria-placeholder="Select a ContractType"
                id="status"
                value={{
                  label: formData.contractType ?? "", 
                  value: formData.contractType?.toString() ?? "", 
                }}
                
                //value={{ label: formData.stockCodeId, value: formData.stockCode }}
                options={[{label:"LEASE",value:"LEASE"},{label:"RENTAL",value:"RENTAL"}, {label:"OWNER",value:"OWNER"}]}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  handleSelect2Change({ target: { value: newValue } })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select contract type"
                    required
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
           <Grid item xs={12} sm={6} md={3}>
          <h6>Comments</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="comments">Comments</InputLabel> */}
              <Input
                id="comments"
                value={formData.comments}
                className="bg-white"
                onChange={(e) => handleChange(e, "comments")}
              />
            </FormControl>
          </Grid>
           <Grid item xs={12} sm={6} md={3}>
          <h6>Attach Files</h6>
            <FormControl fullWidth>
              {/* <InputLabel shrink htmlFor="fileUpload">Attach Files</InputLabel> */}
              <Input
                id="fileUpload"
                type="file"
                className="bg-white"
                inputProps={{ multiple: true, accept: ".pdf, .xls, .xlsx" }}
                onChange={handleFileUpload}
                style={{ fontSize: "14px" }}
              />
            </FormControl>

              {
              formData?.attachments && formData?.attachments.length > 0 && (
                <List sx={{ width: "100%", bgcolor: "background.paper", p: 2 }}>
                  {formData.attachments.map((file, index) => (
                    <ListItem 
                      key={index} 
                      sx={{
                        display: "flex", 
                        flexDirection: { xs: "column", sm: "row" }, // Stacks on small screens
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        borderBottom: "1px solid #ddd",
                        pb: 1,
                        mb: 1,
                      }}
                    >
                      {/* File Name */}

                      {/* Action Buttons */}
                      <Box display="flex" justifyContent={"space-between"} gap={1}>
                        {/* <Typography variant="body1" 
                          // sx={{ flexGrow: 1, wordBreak: "break-word" }}
                        > */}
                          {file.name}
                          <DownloadIcon
                            titleAccess="Download"
                            onClick={() => {
                              const fileUrl = `${FILE_DOWNLOAD_PREVIEW + file.attachmentId}`;
                              const link = document.createElement("a");
                              link.href = fileUrl;
                              link.setAttribute("download", ""); // Ensures download behavior
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                            color="primary"
                          />
                        <CloseIcon
                          color="error"
                          onClick={() => removeFile(index)}
                          titleAccess="Remove"
                        />
                        {/* </Typography> */}
                      </Box>
                    </ListItem>
                  ))}
                </List>
              )
            }
          </Grid>
          </Grid>
         </Box>
      
    </div>
     <div>
    <Typography
          variant="h6"
          gutterBottom
          sx={{ marginBottom: 1, color: "#004489", fontSize: "16px", fontWeight: "bold" }}
        >
          Specifications - {selectedFamilyName}
        </Typography>
      <Box
        sx={{
          borderRadius: 2,
          boxShadow: 3,
          padding: 2, // Add padding for better spacing
          backgroundColor: "#FFFFFF",
          border: "12px solid #F9F9F9;",
          marginBottom: 3,
        }}
        component="form"
        
      >
       
        <Grid container spacing={3}>
           
          <Grid item xs={12} sm={6} md={3}>
          <h6>Select a Manufacturer</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-label="Select a Manufacturer"
                id="manufacturerName"
                className="bg-white"
                value={{
                  label: formData.manufacturerName,
                  value: formData.manufacturerId,
                }}
                options={manufacturer}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                handleSelectManufacturerChange({ target: { value: newValue } }, "manufacturerName", "manufacturerId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Selct an Manufacturer"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Select a Model</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-label="Select an model"
                id="model"
                className="bg-white"
                value={{
                  label: formData.modelName,
                  value: formData.modelId,
                }}
                options={models}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  handleSelectChange({ target: { value: newValue } }, "modelName", "modelId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select a Model"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
         
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <h6>Sr No</h6>
              <Input
                id="srNo"
                className="bg-white"
                value={formData.srNo}
                onChange={(e) => handleChange(e,"srNo")}
              />
            </FormControl>
          </Grid>   
          <Grid item xs={12} sm={6} md={3}>
          <h6>Manufaturer Date</h6>
            <FormControl fullWidth>
              <Calendar
                id="manufacturerDate"
                className="h-29"
                value={
                  formData.manufacturerDate
                    ? new Date(formData.manufacturerDate)
                    : null
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    manufacturerDate: e.value as Date | any,
                  })
                }
                showIcon
                dateFormat="mm/dd/yy"
                placeholder="Manufacturer Date"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
          <h6>Tech Additional</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="techAdditional">Tech Additional</InputLabel> */}
              <Input
                id="techAdditional"
                className="bg-white"
                value={formData.techAdditional}
                onChange={(e) => handleChange(e, "techAdditional")}
              />
            </FormControl>
          </Grid>
           {optionalFields.map(({ key, formKey, type }) => {
            const optionalValue = selectedFamily[0]?.[key as keyof assetFamilyMaster];

            return (
              optionalValue && optionalValue !== "" && (
                <Grid item xs={12} sm={6} md={3} key={key}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor={optionalValue.toString()}>{optionalValue}</InputLabel>
                    <Input
                      id={optionalValue.toString()}
                      value={formData[formKey]}
                      onChange={(e) => handleChange(e, formKey)}
                      type={type}
                    />
                  </FormControl>
                </Grid>
              )
            );
          })}
         </Grid>
         </Box>
      
    </div>
     <div>
    <Typography
          variant="h6"
          gutterBottom
          sx={{ marginBottom: 1, color: "#004489", fontSize: "16px", fontWeight: "bold" }}
        >
          Accounting - {selectedFamilyName}
        </Typography>
      <Box
        sx={{
          borderRadius: 2,
          boxShadow: 3,
          padding: 2, // Add padding for better spacing
          backgroundColor: "#FFFFFF",
          border: "12px solid #F9F9F9;",
          marginBottom: 3,
        }}
        component="form"
        
      >
       
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Purchase Date</h6>
            <FormControl fullWidth>
              <Calendar
                id="purchaseDate"
                className="h-29"
                value={
                  formData.purchaseDate ? new Date(formData.purchaseDate) : null
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    purchaseDate: e.value as Date | any,
                  })
                }
                showIcon
                dateFormat="mm/dd/yy"
                placeholder="Purchase Date"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Purchase Value</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="insuranceValue">Insurance Value</InputLabel> */}
              <Input
                id="purchaseValue"
                className="bg-white"
                value={formData.purchaseValue}
                onChange={(e) => handleChange(e, "purchaseValue")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Insurance Value</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="insuranceValue">Insurance Value</InputLabel> */}
              <Input
                id="insuranceValue"
                className="bg-white"
                value={formData.insuranceValue}
                onChange={(e) => handleChange(e, "insuranceValue")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Insurance Company</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="insuranceValue">Insurance Value</InputLabel> */}
              <Input
                id="insuranceCompany"
                className="bg-white"
                value={formData.insuranceCompany}
                onChange={(e) => handleChange(e, "insuranceCompany")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Select an Insurance Currency</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-placeholder="Select an Insurance Currency"
                id="insuranceCurrency"
                className="bg-white"
                value={{
                  label: formData.insuranceCurrency,
                  value: formData.insuranceCurrencyId,
                }}
                options={insuranceCurrency}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  handleSelectChange({ target: { value: newValue } }, "insuranceCurrency", "insuranceCurrencyId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select an Insurance Currency"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
           <Grid item xs={12} sm={6} md={3}>
          <h6>Capex Form Ref</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="capexFormRef">Capex Form Ref</InputLabel> */}
              <Input
                id="capexFormRef"
                className="bg-white"
                value={formData.capexFormRef}
                onChange={(e) => handleChange(e, "capexFormRef")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <h6>Group Code</h6>
            <FormControl fullWidth>
              <Input
                id="groupCode"
                className="bg-white"
                value={formData.groupCode}
                onChange={(e) => handleChange(e, "groupCode")}
              />
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <h6>No Charge</h6>
            <FormControl fullWidth>
              <Input
                id="noCharge"
                className="bg-white"
                value={formData.noCharge}
                onChange={(e) => handleChange(e, "noCharge")}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <h6>Half Shift</h6>
            <FormControl fullWidth>
              <Input
                id="halfShiftCharge"
                className="bg-white"
                value={formData.halfShiftCharge}
                onChange={(e) => handleChange(e, "halfShiftCharge")}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <h6>Full Shift</h6>
            <FormControl fullWidth>
              <Input
                id="fullShiftCharge"
                className="bg-white"
                value={formData.fullShiftCharge}
                onChange={(e) => handleChange(e, "fullShiftCharge")}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <h6>Double Shift</h6>
            <FormControl fullWidth>
              <Input
                id="doubleShiftCharge"
                className="bg-white"
                value={formData.doubleShiftCharge}
                onChange={(e) => handleChange(e, "doubleShiftCharge")}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <h6>Rate Option 1</h6>
            <FormControl fullWidth>
              <Input
                id="rateop1"
                className="bg-white"
                value={formData.rateop1}
                onChange={(e) => handleChange(e, "rateop1")}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <h6>Rate Option 2</h6>
            <FormControl fullWidth>
              <Input
                id="rateop2"
                className="bg-white"
                value={formData.rateop2}
                onChange={(e) => handleChange(e, "rateop2")}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              {/* File Upload */}
              <FormControl fullWidth sx={{ flex: 1 }}>
                <h6>Attach Capex Attachment</h6>
                <Input
                  id="fileUpload"
                  className="bg-white"
                  type="file"
                  inputProps={{ accept: "image/*" }} // Only image files allowed
                  onChange={handleCapexFileUpload}
                  style={{ fontSize: "14px" }}
                />
              </FormControl>

              {/* Preview List */}
              {formData?.imageAttachments?.length > 0 && (
                <List
                  dense
                  sx={{
                    bgcolor: "background.paper",
                    maxHeight: 200,
                    overflowY: "auto",
                    width: "auto",
                    p: 1,
                    border: "1px solid #eee",
                    borderRadius: 2,
                    flexShrink: 0,
                  }}
                >
                  {formData.capexAttachments.map((file, index) => {
                    const fileUrl = `${FILE_DOWNLOAD_PREVIEW + file.attachmentId}`;
                    return (
                      <ListItem
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          p: 0.5,
                        }}
                      >
                        {/* Image */}
                        <Box sx={{ width: 59, height: 59, flexShrink: 0 }}>
                          <ImagePreview
                            src={fileUrl}
                            alt={file?.name || "Image Preview"}
                          
                            style={{
                              width: "59px",
                              height: "59px",
                              borderRadius: "50%",
                              objectFit: "cover"
                            }}
                          />
                        </Box>

                        {/* Actions */}
                        <Box display="flex" flexDirection="column" gap={0.5}>
                          <IconButton
                            size="small"
                            onClick={() => {
                              const link = document.createElement("a");
                              link.href = fileUrl;
                              link.setAttribute("download", file.name || "image");
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                          >
                            <DownloadIcon fontSize="small" color="primary" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => removeCapexImageFile(index)}
                          >
                            <CloseIcon fontSize="small" color="error" />
                          </IconButton>
                        </Box>
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </Stack>
          </Grid>
          </Grid>
         </Box>
      
    </div>
     <div>
    <Typography
          variant="h6"
          gutterBottom
          sx={{ marginBottom: 1, color: "#004489", fontSize: "16px", fontWeight: "bold" }}
        >
          Logistics - {selectedFamilyName}
        </Typography>
      <Box
        sx={{
          borderRadius: 2,
          boxShadow: 3,
          padding: 2, // Add padding for better spacing
          backgroundColor: "#FFFFFF",
          border: "12px solid #F9F9F9;",
          marginBottom: 3,
        }}
        component="form"
        
      >
       
        <Grid container spacing={3}>
           <Grid item xs={12} sm={6} md={3}>
          <h6>COO</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="coo">COO</InputLabel> */}
              <Input
                id="coo"
                value={formData.coo}
                className="bg-white"
                onChange={(e) => handleChange(e, "coo")}
                // required
              />
            </FormControl>
          </Grid>
            <Grid item xs={12} sm={6} md={3}>
          <h6>Length</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="length">Length</InputLabel> */}
              <Input
                id="length"
                value={formData.length}
                className="bg-white"
                onChange={(e) => handleChange(e, "length")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Width</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="width">Width</InputLabel> */}
              <Input
                id="width"
                value={formData.width}
                className="bg-white"
                onChange={(e) => handleChange(e, "width")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Height</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="height">Height</InputLabel> */}
              <Input
                id="height"
                value={formData.height}
                className="bg-white"
                onChange={(e) => handleChange(e, "height")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Weight</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="weight">Weight</InputLabel> */}
              <Input
                id="weight"
                value={formData.weight}
                className="bg-white"
                onChange={(e) => handleChange(e, "weight")}
                // required
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <h6>Hs Code</h6>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="hsCode">Hs Code</InputLabel> */}
              <Input
                id="hsCode"
                value={formData.hsCode}
                className="bg-white"
                onChange={(e) => handleChange(e, "hsCode")}
                // required
              />
            </FormControl>
          </Grid>
            <Grid item xs={12} sm={6} md={3}>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              {/* File Upload */}
              <FormControl fullWidth sx={{ flex: 1 }}>
                <h6>Attach Logistics Attachment</h6>
                <Input
                  id="fileUpload"
                  className="bg-white"
                  type="file"
                  inputProps={{ accept: "image/*" }} // Only image files allowed
                  onChange={handleLogisticsFileUpload}
                  style={{ fontSize: "14px" }}
                />
              </FormControl>

              {/* Preview List */}
              {formData?.logisticsAttachments?.length > 0 && (
                <List
                  dense
                  sx={{
                    bgcolor: "background.paper",
                    maxHeight: 200,
                    overflowY: "auto",
                    width: "auto",
                    p: 1,
                    border: "1px solid #eee",
                    borderRadius: 2,
                    flexShrink: 0,
                  }}
                >
                  {formData.logisticsAttachments.map((file, index) => {
                    const fileUrl = `${FILE_DOWNLOAD_PREVIEW + file.attachmentId}`;
                    return (
                      <ListItem
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          p: 0.5,
                        }}
                      >
                        {/* Image */}
                        <Box sx={{ width: 59, height: 59, flexShrink: 0 }}>
                          <ImagePreview
                            src={fileUrl}
                            alt={file?.name || "Image Preview"}
                          
                            style={{
                              width: "59px",
                              height: "59px",
                              borderRadius: "50%",
                              objectFit: "cover"
                            }}
                          />
                        </Box>

                        {/* Actions */}
                        <Box display="flex" flexDirection="column" gap={0.5}>
                          <IconButton
                            size="small"
                            onClick={() => {
                              const link = document.createElement("a");
                              link.href = fileUrl;
                              link.setAttribute("download", file.name || "image");
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                          >
                            <DownloadIcon fontSize="small" color="primary" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => removeLogisticsImageFile(index)}
                          >
                            <CloseIcon fontSize="small" color="error" />
                          </IconButton>
                        </Box>
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </Stack>
          </Grid>
          
          </Grid>
         </Box>
           <Grid item xs={12}>
          <Box
            sx={{ display: "flex", justifyContent: "end", marginTop: 2 }}
          >              
            <Button   severity="secondary" onClick={handleClear}>
              Cancel
            </Button>
            {userDetails.role.some(
              r => r.roleName === "Admin" || r.roleName === "Assets Write"
            ) && (
              <Button
                severity="info"
                onClick={handleSubmit}
                color="primary"
                style={{ marginLeft: 2 }}
              >
                Save
              </Button>
            )}

          </Box>
        </Grid>
      
    </div>

   
    
    
  </>
);
};

export default CreateAsset;


